import Head from 'next/head';
import React, { ReactElement } from 'react';
import Section from 'components/ToolForgotPassword/Section';

const ForgotPassword = (): ReactElement => {
  return (
    <>
      <Head>
        <title>Society Forgot Password | Huzzle</title>
        <meta
          name="description"
          content="Forgot your password? Reset it here for your Society account."
        />
      </Head>
      <Section />
    </>
  );
};

export default ForgotPassword;
